export default __webpack_public_path__ + "static/media/first.86eb51c6.svg";